import React from 'react'

import SidebarComp from 'components/Sidebar'
import { useAppSelector } from 'redux/Hook'
import { Participant } from 'lib/authorization/Roles'

const Sidebar = () => {
  const { roleName } = useAppSelector((state) => state.user.user)

  // Hide admin sidebar for participants
  if (roleName === Participant) return <></>

  return <SidebarComp />
}

export default Sidebar
